'use strict';

var RulesReadonlySummaryDirective = function RulesReadonlySummaryDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-readonly-summary.html'),
    controller: 'RulesReadonlySummaryController',
    scope: {
      rule: '='
    }
  };
};
RulesReadonlySummaryDirective.$inject = [];
module.exports = RulesReadonlySummaryDirective;